import { useEffect } from "react";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from "react-slick";
import { useAppSelector } from "../../app/hooks";
import { selectResourceId } from "../../app/auth/createAuthSlice";
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri";
import { useLazyGetHomeBannerQuery } from "../../app/appApiSlice";
import Button from "../../components/Button";
import { IBannerItem } from "../../app/models/HomeModal";
import SkeletonBanner from "../../components/Skelton/SkeletonBanner";

const NextArrow = (props: any) => {

  const { onClick } = props;
  return (
    <button
      className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 z-10 bg-bgArrow text-white shadow-md rounded-full p-1 sm:p-2"
      onClick={onClick}
    >
      <RiArrowRightSLine size={24} />
    </button>
  );
};

const PrevArrow = (props: any) => {
  const { onClick } = props;
  return (
    <button
      className="absolute left-2 sm:left-4 top-1/2 -translate-y-1/2 z-10 bg-bgArrow text-white shadow-md rounded-full p-1 sm:p-2"
      onClick={onClick}
    >
      <RiArrowLeftSLine size={24} />
    </button>
  );
};
const HomeSlider = () => {
  const resourceId = useAppSelector(selectResourceId);
  const [getHomeBannerData, { data: homeBannerData, isLoading, error }] = useLazyGetHomeBannerQuery();

  useEffect(() => {
    if (resourceId) {
      getHomeBannerData(resourceId);
    }
  }, []);

  const bannerButtonClick = (url: string) => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,

    // Auto slide settings
    autoplay: false,
    autoplaySpeed: 3000, // 3 seconds
    pauseOnHover: true,

    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className=" ">

      {/* Homepage Slider */}
      <div className="slider-container alumni-slider relative">

        {
          isLoading ?
            <SkeletonBanner className="w-full h-[300px] md:h-[400px] rounded-md" /> :
            error ?
              "Error loading banner data" :
              homeBannerData?.banner?.length === 0 ?
                <div className="flex items-center justify-center">
                  <span className="text-lg font-medium">No banner data available</span>
                </div> :
                <Slider {...settings}>
                  {homeBannerData?.banner?.map((bannerItem: IBannerItem) => (
                    <div className={` ${bannerItem?.bannerCategory === "Leadership Message" || bannerItem?.bannerCategory === "Letter from the CEO"
                      ? "bg-black" : ` `} min-h-[554px]! md:!min-h-[400px] bg-cover`} key={bannerItem.bannerId}
                    >
                      <div className="relative w-full h-auto  md:h-[400px] ">
                        {bannerItem?.bannerCategory === "Leadership Message" || bannerItem?.bannerCategory === "Letter from the CEO" ? (
                          <div className="w-full h-full object-cover bg-black" >

                          </div>
                        ) : (
                          <img src={bannerItem?.mediaUrl} alt={bannerItem?.title} className="w-full h-full object-cover" />
                          // <img src="https://alumniportaldevsa.blob.core.windows.net/alumnidev/HeroBanner/StateAI.png?sp=rl&st=2026-05-26T05:26:31Z&se=2027-05-26T13:41:31Z&spr=https&sv=2026-02-06&sr=c&sig=H9JMTfL1f8gJP6KLbcWaDo7AyUz75YgOF29zotgeWTI%3D" className="w-full h-full object-cover" />
                        )}


                        <div className={`md:bg-gradient-to-l bg-gradient-to-b from-black/0 via-black/40 via-black/70 to-black/98 p-4  md:p-[3rem]  h-full min-h-[554px]! md:!min-h-[400px] absolute top-0 left-0 ${
                          ["Leadership Message", "Letter from the CEO"].includes(
                            bannerItem?.bannerCategory
                          )
                            ? ""
                            : "pt-[200px]"
                        }`}>
                          <div className='flex flex-col md:flex-row  sm:space-y-6 md:space-y-0 items-center '>
                            <div className='md:w-[60%] sm:w-full md:px-10 order-2 md:order-1 text-center md:text-left'>
                              {
                                bannerItem?.bannerCategory === "Letter from the CEO" && 
                                <span className='sm:text-xs sm:text-base text-white font-semibold bg-bgDarkGreen/40 p-2'>
                                  {bannerItem?.bannerCategory}
                                </span>
                              }
                              <h2 className='text-brand text-xl sm:text-3xl px-[30px] sm:p-0 sm:w-auto font-semibold my-5'>
                                {bannerItem?.title}
                              </h2>
                              <p className='text-textlightGrey text-sm mb-6 sm:mb-10'>
                                {bannerItem?.description}
                              </p>
                              <Button onClick={() => bannerButtonClick(bannerItem?.buttonUrl)} variant="primary"> {bannerItem?.buttonText || "Learn More"} </Button>
                            </div>
                            <div className='md:w-[40%] sm:w-full order-1 md:order-2'>
                              <>
                                {/* {bannerItem?.bannerCategory === "Leadership Message" ? (
                          <img src={bannerItem?.mediaUrl} alt={bannerItem?.title} />
                        ) : (
                          <img src="../assets/img/greenCircle.png" alt={bannerItem?.title} />
                        )} */}

                                {bannerItem?.bannerCategory === "Leadership Message" || bannerItem?.bannerCategory === "Letter from the CEO" && (
                                  <img
                                    src={bannerItem?.mediaUrl}
                                    alt={bannerItem?.title}
                                    className="sm:w-auto w-[65%] mx-auto mb-5 sm:mb-0"
                                  />
                                )}
                              </>




                              {/* <img src="../assets/img/greenCircle.png" alt={bannerItem?.title} />  */}
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
                  ))}
                </Slider>
        }
      </div>


    </div>
  );
};

export default HomeSlider;
